import { Card } from '@mui/material';
import { map } from 'lodash';
import { ComponentType, Fragment, useEffect } from 'react';
import SimpleBar from 'simplebar-react';
import { TestQuestionsItem } from '../test-questions-item';
import useStyles from './styles';

interface TestQuestionsProps {
  userAnswers?: any[];
  questions: Record<string, any>[];
  qIndex?: number;
  handleChange?: (question: number, answer: number) => void;
  // mode?: 'test' | 'result';
  highlightError?: boolean;
  onlyAnswers?: boolean;
  disabled?: boolean;
}
export const TestQuestions: ComponentType<TestQuestionsProps> = ({
  userAnswers = [],
  questions,
  qIndex,
  handleChange,
  // mode = 'test',
  highlightError = false,
  onlyAnswers = false,
  disabled = false,
}) => {
  const classes = useStyles();

  useEffect(() => {
    const scrollableContainer: any = document.querySelector('.simplebar-content-wrapper');
    const scrollableContent: any = document.querySelector('.simplebar-content');
    if (scrollableContainer && scrollableContent && (qIndex || qIndex === 0)) {
      scrollableContainer.scrollTo({ top: scrollableContent.children.item(qIndex).offsetTop - 32 });
    }
  }, [qIndex]);

  return (
    <Card className={classes.root}>
      <SimpleBar className={classes.container}>
        {map(questions, (item, index) => (
          <Fragment key={index}>
            <TestQuestionsItem
              {...{
                userAnswers,
                item,
                index,
                handleChange,
                // mode,
                highlightError,
                hideQuestion: onlyAnswers,
                disabled,
              }}
            />
          </Fragment>
        ))}
      </SimpleBar>
    </Card>
  );
};
